import { InputProps } from '@chakra-ui/react'
import format from 'date-fns/format'
import { forwardRef, useEffect, useState } from 'react'
import { UseFormClearErrors } from 'react-hook-form'
import { BimabossDatePicker } from './BimabossDatePicker'

interface IUncontrolledBimabossDatePickerProps extends InputProps {
  initialDate?: Date
  minDate?: Date
  maxDate?: Date
  clearErrors?: UseFormClearErrors<any>
  onDateChange?: (formattedDate: string) => void
  onUnmount?: () => void
}

const UncontrolledBimabossDatePicker = forwardRef(
  (props: IUncontrolledBimabossDatePickerProps, ref) => {
    const { initialDate, onDateChange, onUnmount, ...rest } = props

    const [date, setDate] = useState(initialDate ? format(initialDate, 'dd/MM/yyyy') : '')

    useEffect(() => {
      if (onDateChange) onDateChange(date)
    }, [date])

    useEffect(() => {
      if (initialDate) {
        setDate(format(initialDate, 'dd/MM/yyyy'))
      }
    }, [initialDate])

    useEffect(() => {
      return () => {
        if (onUnmount) onUnmount()
      }
    })

    return (
      <>
        <BimabossDatePicker inputDate={date} setInputDate={setDate} {...rest} />
      </>
    )
  },
)

UncontrolledBimabossDatePicker.displayName = 'UncontrolledBimabossDatePicker'

export { UncontrolledBimabossDatePicker }
